module.exports = __webpack_public_path__ + "static/media/Nota vive la mejor version.4d41caef.jpg";